//@ts-nocheck

import { useEffect } from 'react';
import { socket } from '../../../socket';

/**
 * Custom hook to manage trip socket connections
 * @param {string|null} tripId - The ID of the trip being signed
 * @param {Function} onEventUpdate - Callback function to handle event updates
 * @returns {Object} socket - The socket instance
 */
export const useAppDataSocket = (tripId, onEventUpdate) => {
  useEffect(() => {
    if (!tripId) return;

    // Join trip-specific room
    socket.emit('join_trip', tripId);

    // Listen for trip status updates
    socket.on(`trip_event_${tripId}`, (event) => {
      onEventUpdate(event);
    });

    // Cleanup
    return () => {
      socket.off(`trip_event_${tripId}`);
      socket.emit('leave_trip', tripId);
    };
  }, [tripId, onEventUpdate]);

  return socket;
};
